import * as yup from 'yup';

export const validationSchema = yup.object({
  examinerLicenseNumber: yup.string(),
  expirationDate: yup
    .string()
    .test('expirationDate', 'Type full date', (val) => {
      if (val) {
        try {
          const date = Number.isNaN(+val)
            ? new Date(Date.parse(val))
            : new Date(+val);
          return (
            date &&
            date.getDate().toString().length >= 1 &&
            date.getMonth().toString().length >= 1 &&
            date.getFullYear().toString().length >= 4
          );
        } catch (error: any) {
          return false;
        }
      }
      return false;
    })
    .required(),
  verifiedLicenseNumber: yup.string(),
  issueDate: yup
    .string()
    .test('issueDate', 'Type full date', (val) => {
      if (val) {
        try {
          const date = Number.isNaN(+val)
            ? new Date(Date.parse(val))
            : new Date(+val);
          return (
            date &&
            date.getDate().toString().length >= 1 &&
            date.getMonth().toString().length >= 1 &&
            date.getFullYear().toString().length >= 4
          );
        } catch (error: any) {
          return false;
        }
      }
      return false;
    })
    .required(),
});
